/** @format */

import { ChangeDetectionStrategy, Component, input, output, Signal } from '@angular/core';

import { CommonModule } from '@angular/common';
import { CompareBarProduct } from '@shared/data-access/interfaces';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'plp-components-compare-thumbnail',
	imports: [CommonModule, HomefieldIconLibraryModule, HmfButtonComponent],
	templateUrl: './compare-thumbnail.component.html',
	styleUrl: './compare-thumbnail.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompareThumbnailComponent {
	readonly compareData: Signal<CompareBarProduct | null> = input(null);

	readonly remove = output<string>();

	onRemove(): void {
		this.remove.emit(this.compareData()?.ecode);
	}
}
